<template>
  <div v-if="type === 'canvas'" :id="ID" class="qrcode qrcode-canvas"></div>
  <div v-else class="qrcode qrcode-image">
    <img :id="ID" :style="{ width: `${width}px`, height: `${width}px` }" />
  </div>
</template>

<script lang="ts">
/**
 * @todo 添加loadingFixedWidth
 * @todo 添加twoChineseChars
 */
import type { PropType } from 'vue';
import { defineComponent, ref, onMounted, computed, toRefs, inject } from 'vue';
import QRCode from 'qrcode';
import { QrcodeTypes, QRCODE_TYPES } from './constants';

export default defineComponent({
  name: 'Qrcode',
  components: {},
  props: {
    /**
     * @zh 二维码的类型，分为两种：canvas、image
     * @en There are two types of two-dimensional code: Canvas and image.
     * @defaultValue 'Canvas'
     */
    type: {
      type: String as PropType<QrcodeTypes>,
      default: QRCODE_TYPES[0],
      validator: (value: any) => {
        return QRCODE_TYPES.includes(value);
      },
    },
    /**
     * @zh 二维码文本内容
     * @en The text content
     */
    text: {
      type: String,
      required: true,
    },
    /**
     * @zh 宽度
     * @en width
     */
    width: {
      type: Number,
    },
    /**
     * @zh 黑暗
     * @en dark
     */
    dark: {
      type: String,
    },
    /**
     * @zh light
     * @en light
     */
    light: {
      type: String,
    },
  },
  emits: {
    /**
     * @zh 获取 Url
     * @en get Url
     * @property {HTMLCanvasElement | string} url
     */
    getUrl: (url: HTMLCanvasElement | string) => true,
  },
  /**
   * @zh 图标
   * @en Icon
   * @slot icon
   */
  setup(props, { emit }) {
    // 动态节点id，防止多个覆盖显示
    const ID = Math.random().toString(36).substr(2);

    // 图片地址
    const DATA_URL = ref('');

    /**
     * 初始化
     * 根据配置显示 canvas 还是 image
     */
    const init = () => {
      const OPTION = {
        margin: 0,
        width: Number(props.width),
        color: {
          dark: props.dark,
          light: props.light,
        },
      };
      if (props.type === 'canvas') {
        QRCode.toCanvas(
          props.text,
          OPTION,
          (err: any, canvas: HTMLCanvasElement) => {
            if (err) throw err;
            const container: HTMLElement | null = document.getElementById(ID);
            if (!container) return;

            container && (container as HTMLElement).appendChild(canvas);
            emit('getUrl', canvas);
          }
        );
      } else if (props.type === 'image') {
        QRCode.toDataURL(props.text, OPTION, (err: any, url: any) => {
          if (err) throw err;
          const image: HTMLElement | null = document.getElementById(ID);

          if (!image) return;
          (image as HTMLImageElement).src = url;
          DATA_URL.value = url;
          emit('getUrl', DATA_URL.value);
        });
      }
    };

    onMounted(() => init());
    return {
      ID,
    };
  },
});
</script>
